import {
  DailyQuestionAnswer,
  DailyQuestionDto,
  OfficeQuestionDto,
} from 'src/api/FiretrolApiClient';

/**
 * Builds the answer rows a daily starts with: the office's question list first,
 * then the questions configured on the job. Answers are stored on the daily by
 * their position in this list, so office rows keep the indexes they have always
 * had and job rows are numbered after them.
 */
export const buildDailyQuestionAnswers = (
  officeQuestions: OfficeQuestionDto[] | undefined,
  jobQuestions: DailyQuestionDto[] | undefined,
): DailyQuestionAnswer[] => {
  const office = officeQuestions ?? [];
  const job = [...(jobQuestions ?? [])].sort(
    (a, b) => (a.order ?? 0) - (b.order ?? 0) || a.id - b.id,
  );

  return [
    ...office.map((q) => q.question),
    ...job.map((q) => q.question ?? ''),
  ].map((question, index) => ({
    id: index,
    question,
    note: '',
    value: 'yes',
  }));
};
